import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const STORE_FRONT_TOKEN_STORAGE_KEY = 'store-front-token';

interface StoreFrontAuthState {
  isLoggedIn: boolean;
}

const initialState: StoreFrontAuthState = {
  isLoggedIn: false
};

const slice = createSlice({
  name: 'store-front-auth',
  initialState,
  reducers: {
    login(state: StoreFrontAuthState, action: PayloadAction<string>) {
      localStorage.setItem(STORE_FRONT_TOKEN_STORAGE_KEY, action.payload);
      state.isLoggedIn = true;
    },
    logout(state: StoreFrontAuthState) {
      localStorage.removeItem(STORE_FRONT_TOKEN_STORAGE_KEY);
      state.isLoggedIn = false;
    }
  }
});

export default slice;
export const selectors = {
  selectIsLoggedIn: (state: StoreFrontAuthState) => state.isLoggedIn,
  selectAuthToken: () => localStorage.getItem(STORE_FRONT_TOKEN_STORAGE_KEY)
};
